import React from 'react'
import alertIcon from '../../../images/alert.svg'

export default function PermissionsNotice() {
  return (
    <div className="container-without-permission">
      <div className="exclamation-point-without-permission">
        <img src={alertIcon} className="svg-alert-icon" alt="without-permission" />
      </div>
      <div className="title-without-permission">
        <span>Cambios en el sistema</span>
      </div>
      <div className="text-without-permission">
        <span>
          Tus permisos a las herramientas se vieron afectados.
          <br />
          Por favor, contactá al administrador del sistema.
        </span>
      </div>
    </div>
  )
}
